import type { Team, User } from 'api/models';
import { saveMemberData, saveTeamData } from './utils';

export type MembersData = {
  users: Array<User>;
  teams: Array<Team>;
};

// save team, member and team data to indexedDb
export function processMembersData(
  documents: { users: Array<User>; teams: Array<Team> },
  callback: (usersAndTeams: MembersData) => void,
): void {
  Promise.all([saveMemberData(documents.users), saveTeamData(documents.teams)])
    .catch((err) => {
      // eslint-disable-next-line no-console
      console.error('error while saving members and teams', err);
    })
    .finally(() => {
      callback({ teams: documents.teams, users: documents.users });
    });
}
